import _ from "lodash"
import {
  UncontrolledTooltip,
} from "reactstrap"
import { Link } from "react-router-dom"


const AstroListingColumns = (onEdit, onDelete, onSort) => [
  {
    dataField: "firstName",
    text: "First Name",
    sort: true,
    onSort: onSort,
  },
  
  {
    dataField: "email",
    text: "Email"
  },
  {
    dataField: "mobile",
    text: "Mobile",
    headerStyle: (colum, colIndex) => {
      return { width: '150px', textAlign: 'left' };
    },
  },
  {
    dataField: "country",
    text: "Country",
    headerStyle: (colum, colIndex) => {
      return { width: '150px', textAlign: 'left' };
    },
  },
  
  {
    dataField: "activated",
    text: "Active",
    headerStyle: (colum, colIndex) => {
      return { width: '75px', textAlign: 'left' };
    },
    formatter: (cellContent, row) => {
      return (
        <>
          {row.activated === true && (<span className="badge bg-success">Activated</span>)}
          {row.activated === false && (<span className="badge bg-warning">Not Activated</span>)}
        </>
      )
    }
  },
  {
    dataField: "menu",
    isDummyField: true,
    text: "Action",
    headerStyle: (colum, colIndex) => {
      return { width: '50px', textAlign: 'center' };
    },
    formatter: (cellContent, row) => {
      return (
        <>
          <Link to="#" className="text-primary">
            <i className="mdi mdi-pencil font-size-18 mr-2" id="edittooltip" onClick={() => onEdit(row)} />
            <UncontrolledTooltip placement="top" target="edittooltip">
              Edit
            </UncontrolledTooltip>
          </Link>
          {(
            <Link to="#" className="text-danger">
              <i className="mdi mdi-delete font-size-18 mr-2" id="deletetooltip" onClick={() => onDelete(row)} />
              <UncontrolledTooltip placement="top" target="deletetooltip">
                Delete
              </UncontrolledTooltip>
            </Link>
          )}
        </>
      )
    }
  },
]

export default AstroListingColumns
